import clsx from "classnames";
import { useStyles } from "./ServiceSelectionOld.style";
import { useAppDispatch, useAppSelector } from "../../hooks";
import { ServiceSelectionItem } from "./ServiceSelectionItemOld";
import {
  setIsShowService,
  triggerDelayWithTimeout,
} from "../../../store/slices/popup";
import AppBar from "../AppBar/AppBar";
import Avatar from "../../core/Avatar/Avatar";
import { Icon } from "../../core/Icon/Icon";
import { useQuery } from "@apollo/client";
import { getConfigGQL, meGQL } from "../../../graphql";
import { User } from "../../../models/user";
import { PageRoutes } from "../../../constants/historyGaming";
import { useNavigate } from "react-router-dom";
import { servicesList } from "../../../constants/servicesOld";

const ServiceSelectionOld: React.FC<
  React.ButtonHTMLAttributes<HTMLButtonElement>
> = () => {
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { isShowService, isPopupDelayActive } = useAppSelector(
    (state) => state.popup,
  );
  const { data: dataMe } = useQuery(meGQL);
  const { data: dataConfig } = useQuery(getConfigGQL);

  const userRank = User.getCurrentRank({
    wallet: dataMe?.me.coinWallets,
    tierLevels: dataConfig?.config.tierLevels,
    baseCoinType: walletConfig.primaryCurrency.base,
    xp: dataMe?.me?.xp,
  });

  const onCloseServicePopup = () => {
    dispatch(triggerDelayWithTimeout(300));
    dispatch(setIsShowService({ isShowService: false }));
  };

  const onNavigate = (isProfile?: boolean) => {
    navigate(isProfile ? PageRoutes.Profile : PageRoutes.Settings);
  };

  if ((!isShowService && !isPopupDelayActive) || !dataMe) return null;

  return (
    <div
      className={clsx(
        classes.root,
        isShowService ? classes.forwardsAnimate : classes.backwardsAnimate,
      )}
    >
      <AppBar
        leftItems={
          <>
            <Avatar
              url={dataMe.me.avatar ?? ""}
              userRank={userRank}
              alt="avatar-user"
              onClick={() => onNavigate(true)}
            />
            <Icon
              className={classes.icon}
              name="icon-bold-setting-2"
              onClick={() => onNavigate()}
              data-testid="settings-icon"
            />
          </>
        }
        rightItems={
          <Icon
            className={classes.icon}
            name="icon-bold-close"
            onClick={onCloseServicePopup}
            data-testid="close-icon"
          />
        }
      />
      <div className={classes.service}>
        {servicesList.map((item, key) => {
          if (!item?.icon || Object.keys(item.icon).length === 0) return null;
          return (
            <ServiceSelectionItem
              icon={item.icon}
              key={key}
              onClickScrollTo={() => {
                document
                  .getElementById(`service-${item.title}`)
                  ?.scrollIntoView({
                    behavior: "smooth",
                  });
                dispatch(setIsShowService({ isShowService: false }));
              }}
              data-testid="service-app-icon"
            />
          );
        })}
      </div>
    </div>
  );
};

export default ServiceSelectionOld;
